<template lang="pug">
el-empty(
    v-if='!efetuouPesquisa',
    :style='{ minHeight: minHeight + "px" }',
    :class='{ justify: minHeight }'
)
    template(#image)
        svg(
            width='120',
            height='120',
            viewbox='0 0 120 120',
            fill='none',
            xmlns='http://www.w3.org/2000/svg'
        )
            path(
                d='M77.25 77.502L63.5625 63.8145L68.8125 58.5645L82.5 72.252L77.25 77.502ZM42.75 77.502L37.5 72.252L54.75 55.002L50.5 50.752L48.75 52.502L45.5625 49.3145V54.4395L43.8125 56.1895L36.25 48.627L38 46.877H43.125L40 43.752L48.875 34.877C49.7083 34.0436 50.6042 33.4395 51.5625 33.0645C52.5208 32.6895 53.5 32.502 54.5 32.502C55.5 32.502 56.4792 32.6895 57.4375 33.0645C58.3958 33.4395 59.2917 34.0436 60.125 34.877L54.375 40.627L57.5 43.752L55.75 45.502L60 49.752L65.625 44.127C65.4583 43.6686 65.3233 43.1895 65.22 42.6895C65.1167 42.1895 65.0642 41.6895 65.0625 41.1895C65.0625 38.7311 65.9067 36.6578 67.595 34.9695C69.2833 33.2811 71.3558 32.4378 73.8125 32.4395C74.4375 32.4395 75.0317 32.502 75.595 32.627C76.1583 32.752 76.7308 32.9395 77.3125 33.1895L71.125 39.377L75.625 43.877L81.8125 37.6895C82.1042 38.2728 82.3025 38.8453 82.4075 39.407C82.5125 39.9686 82.5642 40.5628 82.5625 41.1895C82.5625 43.6478 81.7192 45.7211 80.0325 47.4095C78.3458 49.0978 76.2725 49.9411 73.8125 49.9395C73.3125 49.9395 72.8125 49.8978 72.3125 49.8145C71.8125 49.7311 71.3333 49.5853 70.875 49.377L42.75 77.502Z',
                fill='#00413C'
            )
            path(
                d='M100 15H20C14.5 15 10 19.5 10 25V80C10 85.5 14.5 90 20 90H35L30 95V105H90V95L85 90H100C105.5 90 110 85.5 110 80V25C110 19.5 105.5 15 100 15ZM100 80H20V25H100V80Z',
                fill='#00413C'
            )
    template(#description)
        .p1.text-center(v-if='p1')
            | {{ p1 }}
        .p2.text-center(v-if='p2')
            | {{ p2 }}
el-empty(
    v-else,
    :style='{ minHeight: minHeight + "px" }',
    :class='{ justify: minHeight }'
)
    template(#description)
        .d-flex.flex-row
            .col-3.ops-text
                | Ops!
            .col-9.side-text.text-left
                | {{ $t('mensagens.preAnaliseCredito.empty.desculpe') }}!
                br
                | {{ $t('mensagens.preAnaliseCredito.empty.naoConseguimosLocalizarNenhumDado') }}.
                br
                | {{ $t('mensagens.preAnaliseCredito.empty.queTalFazerUmaNovaBusca') }}?
</template>

<script>
export default {
    name: 'EmptyResultAnalise',
    props: {
        p1: String,
        p2: String,
        efetuouPesquisa: {
            type: Boolean,
            default: false
        },

        minHeight: {
            type: Number,
            default: 100
        }
    }
};
</script>

<style lang="scss" scoped>
.el-empty {
    font-family: 'Roboto', 'sans serif';
    color: var(--primary-font-color);
    margin-top: 50px;
    margin-bottom: 50px;

    .p1 {
        font-weight: 500;
        font-size: 22px;
        line-height: 25.7px;
        color: #3b3b3b;
        margin-bottom: 16px;
    }

    .p2 {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #3b3b3b;
    }

    .ops-text {
        font-family: 'Roboto', 'sans serif';
        font-weight: 400;
        font-size: 80px;
        line-height: 93.75px;
    }

    .side-text {
        font-family: 'Roboto', 'sans serif';
        font-weight: 400;
        font-size: 17px;
        line-height: 28.8px;
    }
}

.justify {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
